/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginOptionsOidcProvider
 */
export interface LoginOptionsOidcProvider {
    /**
     * The provider name, e.g. 'microsoft' or 'google'
     * @type {string}
     * @memberof LoginOptionsOidcProvider
     */
    providerName: string;
    /**
     * Authority/issuer URL, e.g. 'https://login.microsoftonline.com/<tenant>/v2.0'
     * @type {string}
     * @memberof LoginOptionsOidcProvider
     */
    authorityUrl: string;
    /**
     * Client ID for this OIDC application
     * @type {string}
     * @memberof LoginOptionsOidcProvider
     */
    clientId: string;
}

/**
 * Check if a given object implements the LoginOptionsOidcProvider interface.
 */
export function instanceOfLoginOptionsOidcProvider(value: object): value is LoginOptionsOidcProvider {
    if (!('providerName' in value) || value['providerName'] === undefined) return false;
    if (!('authorityUrl' in value) || value['authorityUrl'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function LoginOptionsOidcProviderFromJSON(json: any): LoginOptionsOidcProvider {
    return LoginOptionsOidcProviderFromJSONTyped(json, false);
}

export function LoginOptionsOidcProviderFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginOptionsOidcProvider {
    if (json == null) {
        return json;
    }
    return {
        
        'providerName': json['provider_name'],
        'authorityUrl': json['authority_url'],
        'clientId': json['client_id'],
    };
}

export function LoginOptionsOidcProviderToJSON(json: any): LoginOptionsOidcProvider {
    return LoginOptionsOidcProviderToJSONTyped(json, false);
}

export function LoginOptionsOidcProviderToJSONTyped(value?: LoginOptionsOidcProvider | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provider_name': value['providerName'],
        'authority_url': value['authorityUrl'],
        'client_id': value['clientId'],
    };
}

